import React, { Component } from 'react';
import { appImgAlt, domainUrl, routeAfterLogin } from '../config/Config';
import { getFormValues } from '../helpers/Fields';
import { getUserData, setUserData, reactLoader, message, getTokenData, parseJwt } from '../helpers/Common';
import { UserId } from '../helpers/User';
import Footer from '../partials/Footer';
import Inputgenerator from '../components/Inputgenerator';
export default class TeleCallFeedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: getUserData("appFullDate", true),
            appImgAlt: appImgAlt,
            formDataList: [],
            questionList: []
        };
    }
    GetTeleCallInfo() {
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "user/telecall/questions", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                user_id: UserId()
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            if (responseJson.status === 0) {
                message(responseJson.message, responseJson.errors, "error");
            } else {
                this.setState({
                    formDataList: responseJson.data,
                    questionList: responseJson.data.questions
                })
            }
        });
    }
    submitFeedback() {
        let jsonFormData = getFormValues(this.state.formDataList);
        reactLoader("show");
        fetch(domainUrl + "post/telecall/feedback", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                user_id: UserId(),
                json_form_data: jsonFormData
            })
        }).then((response) => response.json()).then((responseJson) => {
            if (responseJson.status === 0) {
                message(responseJson.message, responseJson.errors, "error");
            } else {
                let userData = parseJwt(getTokenData());
                if (userData.afterRoutes.length > 1) {
                    userData.afterRoutes.splice(0, 1);
                    setUserData("afterRoutes", userData.afterRoutes, true);
                    setTimeout(() => {
                        reactLoader("hide");
                        this.props.router.push(userData.afterRoutes[0].url);
                    }, 1200);
                } else {
                    setUserData("globalAccess", true, true);
                    setTimeout(() => {
                        setUserData("afterRoutes", [], true);
                    }, 500);
                    setTimeout(() => {
                        reactLoader("hide");
                        this.props.router.push(routeAfterLogin);
                    }, 1200);
                }
            }
        });
    }
    componentWillMount() {
        this.GetTeleCallInfo();
    }
    componentDidMount() {
        document.body.className = "inner";
    }
    render() {
        const feedbackHtml = this.state.questionList.map((val, key) => {
            return <div key={`level1_div_${key}`} className="fdbk-questn">
                <span className="greenbg">{(key + 1)}</span>{val.questionLabel}
                <ul className="ques-block">
                    <li><Inputgenerator qDetails={val} /></li>
                </ul>
            </div>
        })
        return (<div className="row">
            <header>
                <div className="logo"><img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="" title={this.state.appImgAlt} border="0" /></div>
                <div className="top-links reg-page"><img src={process.env.PUBLIC_URL + '/images/calendar_icon.png'} alt="" title="" border="0" /><span>{this.state.date}</span></div>
            </header>
            <section className="maincontent">
                <section className="content">
                    <form method="post" action="#">
                        <h1>Feedback for the Telecall</h1>
                        As a way to let us know about outcomes associated with this course, we would like to you to share your thoughts with us:
						<section id="semana-scroll-register" className="scroll">
                            <section className="viewport">
                                <section className="overview">
                                    <div className="frm">
                                        <div className="slash_txt">
                                            <br />
                                            <div className="feedback-forms">
                                                {feedbackHtml}
                                            </div>
                                            <div className="slash_txtnoP">
                                                <div className="button">
                                                    <span><input type="button" value="Continue" title="Continue" onClick={() => this.submitFeedback()} /></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </form>
                </section>
            </section>
            <Footer />
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/pages/TeleCallFeedback.js